export class AcademicTraining{
    id?: number;
    level: string;
    coursed_years: number;
    title: string;
    institution: string;
    minister_id? : number;
    
    constructor()
    {
        this.id = null;
        this.level = null;
        this.coursed_years = null;
        this.title = null;
        this.institution = null;
        this.minister_id = null;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/AcademicTraining.model.ts